export default "__VITE_ASSET__BEZA7g7R__"